import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { Component } from '@theme/component';

/**
 * @typedef {Object} GradientLinkRefs
 * @property {HTMLElement[]} [productPrice]
 */

/**
 * Updates `{product_price}` and `{product_price_no_currency}` placeholders when the selected variant changes.
 *
 * @extends {Component<GradientLinkRefs>}
 */
class GradientLink extends Component {
  connectedCallback() {
    super.connectedCallback();

    if (!this.querySelector('.gradient-link__price')) return;

    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updatePrice);
  }

  /**
   * Replaces each price placeholder with the server-rendered value for the new variant.
   * @param {VariantUpdateEvent} event
   */
  updatePrice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newGradientLink = event.detail.data.html.querySelector(
      `gradient-link[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newGradientLink) return;

    const newPrices = [...newGradientLink.querySelectorAll('.gradient-link__price')];
    const currentPrices = [...this.querySelectorAll('.gradient-link__price')];

    for (const [index, priceElement] of currentPrices.entries()) {
      const nextPrice = newPrices[index];
      if (nextPrice) {
        priceElement.textContent = nextPrice.textContent;
      }
    }
  };
}

if (!customElements.get('gradient-link')) {
  customElements.define('gradient-link', GradientLink);
}
